import { SignupProps } from "./signup.types";
import { SignupView } from "./signup-view";
import { useSignup } from "./use-signup";

export const Signup: React.FC<SignupProps> = ({ goToLogin, page, linkExpired }) => {
  const logic = useSignup({ page });
  return <SignupView {...logic} goToLogin={goToLogin} linkExpired={linkExpired} />;
};
